import script from "./TreeList.vue?vue&type=script&lang=ts&setup=true"
export * from "./TreeList.vue?vue&type=script&lang=ts&setup=true"

import "./TreeList.vue?vue&type=style&index=0&id=701327d4&lang=css"

const __exports__ = script;

export default __exports__